import { useState } from 'react';
import { API_BASE_URL } from '../utils/constants';
import { Spinner } from '../components/Spinner';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Poruka nije poslata.');
      setSubmitted(true);
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="p-20 justify-center flex">
      {loading ? (
        <Spinner />
      ) : submitted ? (
        <div className="flex items-center justify-center min-h-[30vh]">
          <p className="text-green-600 text-lg text-center">
            Poruka je poslata! Kontaktiraćemo Vas uskoro.
          </p>
        </div>
      ) : (
      <div className="max-w-lg items-center">
        <h1 className="text-2xl font-bold mb-6">Kontaktirajte nas</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Puno ime"
            required
            className="w-full border p-2 rounded"
          />
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email adresa"
            required
            className="w-full border p-2 rounded"
          />
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Poruka"
            rows={4}
            required
            className="w-full border p-2 rounded"
          />
          {error && <p className="text-red-600 text-sm">{error}</p>}
          <button type="submit" className="bg-black text-white px-4 py-2 rounded">
            Pošalji
          </button>
        </form>
      </div>
      )}
    </div>
  );
};

export default Contact;
